import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function Skeleton({ className, ...rest }) {
    return _jsx("span", { className: cn("fwfa-skeleton", className), "aria-hidden": "true", ...rest });
}
//# sourceMappingURL=Skeleton.js.map